export default "__VITE_ASSET__D$MUnbIT__"